import RolesScreen from "../../Base/Screens/IT/Roles/RolesScreen";
import SesionesScreen from "../../Base/Screens/IT/Sesiones/SesionesScreen";
import AccesosScreen from "../../Base/Screens/IT/Accesos/AccesosScreen";

import MenuScreen from "../../Base/Screens/IT/Menu/MenuScreen";
import UsuariosScreen from "../../Base/Screens/IT/Usuarios/UsuariosScreen";
import CalendarioOperativoScreen from "../../Base/Screens/IT/CalendarioOperativo/CalendarioOperativoScreen";
import ListaCorreosScreen from "../../Base/Screens/IT/ListaCorreos/ListaCorreosScreen";
import InformacionEmpresaScreen from "../../Base/Screens/Global/InformacionEmpresa/InformacionEmpresaScreen";
import MetricasScreen from "../../Base/Screens/IT/Metricas/MetricasScreen";
import RegistroMetricasScreen from "../../Base/Screens/IT/Metricas/RegistroMetricasScreen";
import NotificacionesScreen from "../../Base/Screens/IT/Notificaciones/NotificacionesScreen";
import EstadosScreen from "../../Base/Screens/IT/Estados/EstadosScreen";
import TabMaestrosScreen from "../../Screen/ERP/IT/Dispositivos/Maestros/TabMaestrosScreen";
import TabDispositivosScreen from "../../Screen/ERP/IT/Dispositivos/Dispositivos/TabDispositivosScreen";

export const ITRoutes = [
  {
    path: 'IT/Roles',
    permiso: 4,
    element: <RolesScreen />
  },
  {
    path: 'IT/Usuarios',
    permiso: 5,
    element: <UsuariosScreen />
  },
  {
    path: 'IT/Menu',
    permiso: 6,
    element: <MenuScreen />
  },
  {
    path: 'IT/AccessWeb',
    permiso: 7,
    element: <AccesosScreen />
  },
  {
    path: 'IT/Sesiones',
    permiso: 8,
    element: <SesionesScreen />
  },
  {
    path: 'IT/CalendarioOperativo',
    permiso: 50,
    element: <CalendarioOperativoScreen CSM={true} />
  },
  {
    path: 'IT/ListaCorreo',
    permiso: 51,
    element: <ListaCorreosScreen />
  },
  {
    path: 'IT/InformacionEmpresa',
    permiso: 57,
    element: <InformacionEmpresaScreen />
  },
  {
    path: 'IT/Metricas',
    permiso: 63,
    element: <MetricasScreen />
  },
  {
    path: 'IT/RegistroMetricas',
    permiso: 64,
    element: <RegistroMetricasScreen />
  },
  {
    path: 'IT/Notificaciones',
    permiso: 70,
    element: <NotificacionesScreen />
  },
  {
    path: 'IT/Status',
    permiso: 80,
    element: <EstadosScreen />
  },

  //Dispositivos
  {
    path: 'IT/Dispositivos/Maestros',
    permiso: 112,
    element: <TabMaestrosScreen />
  },
  {
    path: 'IT/Dispositivos/dispositivo',
    permiso: 113,
    element: <TabDispositivosScreen />
  },
]

export default ITRoutes;